const SAFE_RENDERED_ARTIFACT_PROTOCOLS = new Set(['http:', 'https:', 'mailto:'])
const SAFE_ARTIFACT_URL_PROTOCOLS = new Set(['http:', 'https:'])
const ARTIFACT_URL_PARSE_BASE = 'https://github.com/'

/**
 * Returns an artifact href when it uses a protocol safe for rendering.
 * Relative and anchor-only hrefs are resolved against the current page by the browser.
 */
export function getSafeArtifactHref(href: string | undefined | null): string | undefined {
  if (!href) return undefined

  try {
    const {protocol} = new URL(href, ARTIFACT_URL_PARSE_BASE)
    return SAFE_RENDERED_ARTIFACT_PROTOCOLS.has(protocol) ? href : undefined
  } catch {
    return undefined
  }
}

/** Returns whether a form value is an absolute HTTP or HTTPS artifact URL. */
export function isValidArtifactUrl(value: string): boolean {
  try {
    // A base would allow relative values, and browser globals are unavailable during SSR.
    // eslint-disable-next-line no-restricted-syntax
    const {protocol} = new URL(value)
    return SAFE_ARTIFACT_URL_PROTOCOLS.has(protocol)
  } catch {
    return false
  }
}
